import { NzSliderModule } from 'ng-zorro-antd/slider';

import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { SliderComponent } from './slider.component';

const COMPONENTS = [SliderComponent];

@NgModule({
  imports: [
    NgCommonModule,
    FormsModule,
    NzSliderModule,
    DragDropModule,
    ScrollingModule,
  ],
  declarations: COMPONENTS,
  exports: [NgCommonModule, COMPONENTS],
})
export class SliderModule {}
